import { apiURL } from '../config';
import {
  EstimateProjectData,
  EstimateProjectResponse,
} from '../models/estimateProject';

export const fetchEstimateProject = async (
  formData: EstimateProjectData
): Promise<EstimateProjectResponse> => {
  try {
    const res = await fetch(`${apiURL}estimate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...formData }),
    });
    return await res.json();
  } catch (e) {
    return await Promise.reject(e);
  }
};
